import { render } from "./ContextMenu.vue?vue&type=template&id=32d42c8a&ts=true"
import script from "./ContextMenu.vue?vue&type=script&lang=ts"
export * from "./ContextMenu.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/ContextMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "32d42c8a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('32d42c8a', __exports__)) {
    api.reload('32d42c8a', __exports__)
  }
  
  module.hot.accept("./ContextMenu.vue?vue&type=template&id=32d42c8a&ts=true", () => {
    api.rerender('32d42c8a', render)
  })

}


export default __exports__